import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

export function LabelToolTip({ labelId, value, value2}) {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
          <FormattedMessage id={labelId} />
        </Tooltip>
      }>
      <div className="d-flex flex-column">
      <span>{value}</span>
      {value2 && <span className="text-secondary"><strong>{value2}</strong></span>}
      </div>
    </OverlayTrigger>
  );
}
